export class NamedError extends Error {
  get name() {
    return this.constructor.name;
  }
}
